import { GridFilterModel } from '@mui/x-data-grid';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../redux/store';
import { API_URL, enrichedFetch } from '../../services/api';
import { Project } from '../../Types/dealGPT';
import { CustomFile } from '../../Types/file';
import { PaginatedResult } from '../../Types/pagination';

export const getIndexedFiles = createAsyncThunk<
  PaginatedResult<CustomFile>,
  {
    indexId: string;
    indexType: Project['indexToUse'];
    page?: number;
    pageSize?: number;
    sortField?: string;
    sortDirection?: 'asc' | 'desc' | null;
    filterModel?: GridFilterModel;
  },
  { state: RootState }
>('indexes/getIndexedFiles', async (params, { rejectWithValue }) => {
  try {
    const url = `${API_URL}/indexes/${params.indexId}/files`;

    const queryParams = new URLSearchParams({
      ...(params.indexType && { indexType: params.indexType }),
      ...(params.page !== undefined && { page: params.page.toString() }),
      ...(params.pageSize !== undefined && { pageSize: params.pageSize.toString() }),
      ...(params.sortField && { sortField: params.sortField }),
      ...(params.sortDirection && { sortDirection: params.sortDirection }),
      ...(params.filterModel?.items?.length && { filterModel: JSON.stringify(params.filterModel) }),
    });

    const response = (await enrichedFetch(`${url}?${queryParams}`)) as PaginatedResult<CustomFile>;
    return response;
  } catch {
    return rejectWithValue('Failed to fetch indexed files');
  }
});
